export const ORDERED_PII_MAPPING = {
  name: ['name_last', 'name_first'],
  business_name: ['business_name'],
  business_alternate_name: ['business_alternate_name'],
  address: [
    'address_line_1',
    'address_line_2',
    'address_city',
    'address_state',
    'address_postal_code',
    'addresses',
  ],
  email: ['email_address'],
  phone: ['phone_number'],
  dob: ['birth_date'],
  ssn: ['document_ssn'],
  business_id: ['business_federal_ein'],
  business_registry_id: ['business_registry_id'],
  document_national_id: ['document_national_id'],
  industries: ['industries'],
  ip_address: ['ip_address_v4', 'ip_address_v6'],
};

export const DUPLICATE_PII_MAPPING = {
  ssn: 'documentSsn',
  email: 'emailAddress',
  phone: 'phoneNumber',
  document_national_id: 'documentNationalId',
  ip_address_v4: 'ipAddressV4',
  ip_address_v6: 'ipAddressV6',
};

export const DISPLAY_NAME_MAPPING = {
  business_registry_id: 'Registry ID',
  business_id: 'Business ID',
};
